import React from "react";
import { styled } from "styled-components";
import { Button, Typography } from "vlab-frontend-components";
import { NotFoundIcon } from "../../assets/not-found";
import { GearIcon } from "../../assets/gear";
import Translator from "../../components/i18n/translator";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url("assets/images/background-404.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  gap: 32px;

  position: relative;

  .decoration {
    position: absolute;
    z-index: 0;

    &:first-child {
      top: 34%;
      left: 26%;

      @media screen and (max-width: 680px) {
        left: 8%;
        top: 28%;
      } 
    }

    &:nth-child(2){
      top: 45%;
      left: 29%;

      @media screen and (max-width: 680px) {
        left: 12%;
        top: 39%;
      }
    }

    &:nth-child(3){
      top: 26%;
      left: 46%;

      @media screen and (max-width: 680px) {
        top: 12%;
      }
    }

    &:nth-child(4){
      top: 20%;
      left: 63%;
    }

    &:nth-child(5) {
      top: 55%;
      left: 60%;
    }
  }

  .not-found {
    z-index: 1;

    @media screen and (max-width: 680px) {
      width: 50%;
    } 
  }
`;

export const NotFound = () => {

  return (
    <Wrapper>
        <GearIcon size={78} className="decoration" />
        <GearIcon className="decoration" />
        <GearIcon size={32} className="decoration" />
        <GearIcon className="decoration" />
        <GearIcon size={78} className="decoration" />
        <NotFoundIcon className="not-found"/>
        <Typography style={{zIndex: 1}} type="bodyL" color="black">
          <Translator path="notFoundedPage" />
        </Typography>
        <Button style={{zIndex: 1}} variant="primary" onClick={() =>{window.location.href = "/"}}>
          <Typography type="buttonS" color="white">
            <Translator path="goBack" />
          </Typography>
        </Button>
    </Wrapper>
  );
}